import * as React from 'react';
import '../assets/Login.scss';
import { Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import LoginAadButton from '../../../LoginAAD/LoginAadButton';

interface ILoginUIProps {
  errorMessage: string;
  onSignIn: (username: string, password: string) => void;
}

interface ILoginComponentState {
  loggingIn: boolean;
  username: string;
  password: string;
  showUsernameError: boolean;
  showPasswordError: boolean;
}

class LoginUI extends React.Component<ILoginUIProps, ILoginComponentState> {
  private usernameInput: HTMLInputElement | null;
  private passwordInput: HTMLInputElement | null;

  constructor(props) {
    super(props);
    this.usernameInput = null;
    this.passwordInput = null;
    this.state = {
      loggingIn: false,
      username: '',
      password: '',
      showUsernameError: false,
      showPasswordError: false
    };
  }

  handleUsernameChange = (e: any) => {
    this.setState({
      username: e.target.value,
      showUsernameError: e.target.value === ''
    });
  };

  handlePasswordChange = (e: any) => {
    this.setState({
      password: e.target.value,
      showPasswordError: e.target.value === ''
    });
  };

  attemptLogin = e => {
    if (!this.state.loggingIn) {
      this.setState(
        {
          showUsernameError: this.state.username === '',
          showPasswordError: this.state.password === '',
          loggingIn: true
        },
        () => {
          if (!this.state.showUsernameError && !this.state.showPasswordError) {
            let signInPromise = new Promise((resolve, reject) => {
              this.props.onSignIn(
                (this.usernameInput as HTMLInputElement).value,
                (this.passwordInput as HTMLInputElement).value
              );
              resolve('Success');
            });

            signInPromise
              .then(() => {
                this.setState({ loggingIn: false });
              })
              .catch(() => {
                console.log('There was an error');
              });
          }
        }
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        {(sessionStorage.getItem('isLocalLogin') === null ||
          sessionStorage.getItem('isLocalLogin') === 'false') && (
          <div>
            <LoginAadButton
              buttonText="Sign in"
              className="btn btn-secondary btn-lg signInButton"
            />
          </div>
        )}
        {sessionStorage.getItem('isLocalLogin') === 'true' && (
          <section className="login-container">
            <div>
              <header className="header align-right">
                <br />
                <LoginAadButton
                  buttonText="NDOT Login"
                  className="btn btn-primary btn-large"
                />
              </header>
              <section className="main-login">
                <div
                  className={
                    'signin-form-element ' +
                    (this.state.showUsernameError ? 'alert-danger' : '')
                  }
                >
                  <input
                    type="text"
                    name="username"
                    placeholder="Username"
                    ref={input => {
                      this.usernameInput = input;
                    }}
                    onChange={this.handleUsernameChange}
                    disabled={this.state.loggingIn}
                    value={this.state.username || ''}
                    onKeyPress={event => {
                      if (event.key === 'Enter') {
                        this.attemptLogin(event);
                      }
                    }}
                  />
                  <i className="fas fa-user" />
                </div>
                <hr className="hr-divider" />
                <div
                  className={
                    'signin-form-element ' +
                    (this.state.showPasswordError ? 'alert-danger' : '')
                  }
                >
                  <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    ref={input => {
                      this.passwordInput = input;
                    }}
                    disabled={this.state.loggingIn}
                    onChange={this.handlePasswordChange}
                    value={this.state.password || ''}
                    onKeyPress={event => {
                      if (event.key === 'Enter') {
                        this.attemptLogin(event);
                      }
                    }}
                  />
                  <i className="fas fa-lock" />
                </div>
              </section>

              {(this.state.showUsernameError ||
                this.state.showPasswordError) && (
                <label className="error">
                  You must correct all fields in red before you can continue
                </label>
              )}
              {this.props.errorMessage !== '' && (
                <label className="error">{this.props.errorMessage}</label>
              )}

              <footer className="signin-footer">
                <div className="forgot-pw align-left">
                  <a href="#">Forgot Password?</a>
                </div>
                <div className="align-right">
                  <button
                    className="btn btn-secondary signin-btn"
                    onClick={e => {
                      this.attemptLogin(e);
                    }}
                  >
                    LexisNexis Sign in
                  </button>
                </div>
              </footer>
            </div>
          </section>
        )}
      </React.Fragment>
    );
  }
}

export default LoginUI;
